import React, { memo } from 'react';
import styled from 'styled-components';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { InputPropsWithDataTestId } from '@mytypes';
import { FONT_SIZES, PALETTE, Z_INDEX } from '~/assets/styles/base';

const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiTypography-root {
    transform: translateY(-0.2rem);
  }
  .MuiCheckbox-root {
    // チェックボックスの背景に白を設定
    position: relative;
    z-index: ${Z_INDEX.base};
    &:after {
      content: '';
      background-color: ${PALETTE.white};
      left: 14px;
      top: 14px;
      height: 14px;
      width: 14px;
      position: absolute;
      z-index: ${Z_INDEX.minus};
    }
  }
  .MuiTypography-root {
    &:hover {
      color: ${PALETTE.primary.main};
    }
  }
`;

const StyledCheckbox = styled(Checkbox)`
  color: #e0e0e0;
  & .MuiIconButton-label {
    position: 'relative';
    z-index: ${Z_INDEX.base};
  }
  &.Mui-checked {
    color: ${PALETTE.primary.main};
  }
  &.Mui-disabled {
    color: #e0e0e0;
  }
`;

type LabelProps = {
  $fontSize?: string;
};
const Label = styled.span<LabelProps>`
  font-size: ${(props) => props.$fontSize};
  margin-right: 14px;
`;

type Props = {
  label: string;
  name: string;
  value: string | number;
  checked: boolean;
  handleChange: CheckboxProps['onClick'];
  className?: string;
  disabled?: boolean;
  dataTestId: string;
  defaultChecked?: boolean;
  fontSize?: number;
  checkboxWidth?: string;
  labelFontSize?: string;
};

const MyCheckbox: React.FC<Props & CheckboxProps> = ({
  label,
  name,
  value,
  checked,
  handleChange,
  className,
  disabled,
  dataTestId,
  defaultChecked,
  fontSize = 24,
  checkboxWidth = 'auto',
  labelFontSize = FONT_SIZES.bodyDefault,
  inputProps,
}): JSX.Element => (
  <FormGroup className={className} row sx={{ width: checkboxWidth }}>
    <StyledFormControlLabel
      control={
        <StyledCheckbox
          color="primary"
          defaultChecked={defaultChecked}
          onClick={handleChange}
          name={name}
          checked={checked}
          disabled={disabled}
          icon={<CheckBoxOutlineBlankIcon style={{ fontSize }} />}
          checkedIcon={<CheckBoxOutlinedIcon style={{ fontSize }} />}
          value={value}
          inputProps={
            {
              ...inputProps,
              'data-testid': `${dataTestId}-checkbox`,
            } as InputPropsWithDataTestId
          }
        />
      }
      label={
        <Label data-testid={`${dataTestId}-label`} $fontSize={`${labelFontSize}`}>
          {label}
        </Label>
      }
    />
  </FormGroup>
);

export default memo(MyCheckbox);
